export default __webpack_public_path__ + "static/media/sumudu_perera.379d720b.jpg";